import React from "react";
import {CircularProgress} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DataUsageIcon from '@mui/icons-material/DataUsage';

export interface SpinnerControlProps {
    isFullScreen: boolean;
}

export const SpinnerControl: React.FC<SpinnerControlProps> = ({isFullScreen}) => {

    return (
        <div style={{position: 'relative'}}>
            <IconButton aria-label="Buffering"><DataUsageIcon sx={{fontSize: isFullScreen ? 60 : 38.5, color: 'white'}}/></IconButton>
            <CircularProgress
                size={42}
                sx={{
                    color: 'white',
                    position: 'absolute',
                    top: 6,
                    left: 6,
                    zIndex: 1,
                }}
            />
        </div>
    );
};

